<template>
  <div class="column" style="height:100%;background: #F1F1F1;">
    <div style="margin-top:10px;height: 100%;">
      <el-container style="height:100%;">
        <el-header style="height: 64px; padding: 0px; ">
          <el-menu
            style="border: 1px solid #eee;margin-left: 10px;"
            default-active="3"
            mode="horizontal"
          >
            <el-menu-item index="3" @click="onOpen(3)">
              <template slot="title">
                <svg
                  t="1646633272179"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5432"
                  width="20"
                  height="20"
                >
                  <path
                    d="M967.9234 816.206954l-147.416093-192.48379c52.29229-49.884092 85.146985-119.721821 85.146985-197.472199 0-150.684361-122.990089-273.330422-274.018478-273.330422-151.200403 0-274.018478 122.646061-274.018478 273.330422s122.990089 273.330422 274.018478 273.330422c48.679993 0 94.263733-12.901058 133.998992-35.090879l147.932135 193.171846c6.70855 8.77272 16.857383 13.417101 27.350244 13.417101 7.224593 0 14.621199-2.236183 20.641693-7.052579C976.524105 852.501932 979.448345 831.172182 967.9234 816.206954L967.9234 816.206954zM421.090543 426.250966c0-115.765496 94.435747-209.857215 210.545271-209.857215s210.545271 94.091718 210.545271 209.857215-94.435747 209.857215-210.545271 209.857215S421.090543 542.016462 421.090543 426.250966L421.090543 426.250966zM288.467663 288.811692 83.254829 288.811692c-18.921552 0-34.230808-15.309256-34.230808-34.058794s15.309256-34.058794 34.230808-34.058794l205.212834 0c18.921552 0 34.230808 15.309256 34.230808 34.058794C322.698471 273.502436 307.389216 288.811692 288.467663 288.811692L288.467663 288.811692zM280.210986 626.131362 83.254829 626.131362c-18.921552 0-34.230808-15.309256-34.230808-34.058794s15.309256-34.058794 34.230808-34.058794l196.956157 0c18.921552 0 34.230808 15.309256 34.230808 34.058794C314.441794 610.822107 299.132538 626.131362 280.210986 626.131362L280.210986 626.131362zM239.78767 457.041492l-156.532841 0c-18.921552 0-34.230808-15.309256-34.230808-34.230808 0-18.921552 15.309256-34.230808 34.230808-34.230808l156.532841 0c18.921552 0 34.230808 15.309256 34.230808 34.230808C273.846464 441.732236 258.537208 457.041492 239.78767 457.041492L239.78767 457.041492zM460.137746 801.241727 83.254829 801.241727c-18.921552 0-34.230808-15.309256-34.230808-34.230808s15.309256-34.230808 34.230808-34.230808l376.882916 0c18.921552 0 34.230808 15.309256 34.230808 34.230808C494.368554 785.932471 479.059298 801.241727 460.137746 801.241727L460.137746 801.241727z"
                    fill="#231815"
                    p-id="5433"
                  />
                </svg>
                &nbsp;&nbsp;历史查询
              </template>
            </el-menu-item>
            <el-menu-item index="2" @click="onOpen(2)">
              <template slot="title">
                <svg
                  t="1646633300709"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5581"
                  width="20"
                  height="20"
                >
                  <path
                    d="M420.352 926.037333C217.770667 875.52 94.037333 669.696 144.554667 467.114667c32.597333-130.730667 133.461333-235.178667 262.997333-272.384a34.184533 34.184533 0 0 0 23.381333-42.154667 34.269867 34.269867 0 0 0-42.154666-23.381333c-152.917333 44.032-271.872 167.253333-310.442667 321.536-59.562667 238.933333 86.357333 481.962667 325.461333 541.696a34.2016 34.2016 0 0 0 41.472-24.917334c4.437333-18.261333-6.656-36.864-24.917333-41.472zM505.514667 179.2h8.533333c18.602667 0 33.792-14.848 34.133333-33.450667 0.341333-18.773333-14.677333-34.474667-33.450666-34.816h-9.216a34.133333 34.133333 0 1 0 0 68.266667zM658.090667 904.533333c-4.949333 2.218667-10.069333 4.266667-15.189334 6.314667-17.578667 6.826667-26.282667 26.624-19.456 44.202667a34.030933 34.030933 0 0 0 44.202667 19.285333c6.144-2.389333 12.117333-4.949333 17.92-7.509333a34.133333 34.133333 0 0 0 17.408-45.056A33.962667 33.962667 0 0 0 658.090667 904.533333zM642.389333 204.8c5.12 2.048 10.24 4.096 15.36 6.314667 4.437333 2.048 9.216 2.901333 13.653334 2.901333a34.133333 34.133333 0 0 0 31.232-20.48c7.509333-17.237333-0.341333-37.376-17.578667-45.056-5.973333-2.56-11.946667-5.12-18.090667-7.509333-17.578667-6.826667-37.376 1.877333-44.202666 19.456-6.656 17.749333 2.048 37.546667 19.626666 44.373333zM858.453333 420.352a34.030933 34.030933 0 0 0 44.202667 19.285333c17.578667-6.826667 26.282667-26.624 19.456-44.202666-2.389333-6.144-4.778667-12.117333-7.509333-17.92a34.133333 34.133333 0 1 0-62.464 27.648c2.218667 4.949333 4.266667 10.069333 6.314666 15.189333zM778.922667 295.936c6.656 6.997333 15.701333 10.410667 24.576 10.410667a34.2016 34.2016 0 0 0 24.746666-57.856c-4.437333-4.608-9.045333-9.216-13.653333-13.653334-13.653333-12.970667-35.157333-12.458667-48.298667 1.024-12.970667 13.653333-12.629333 35.157333 1.024 48.298667 3.754667 3.925333 7.68 7.68 11.605334 11.776zM902.826667 675.498667c-17.578667-6.826667-37.376 1.877333-44.202667 19.456-2.048 5.12-4.096 10.24-6.314667 15.189333a34.133333 34.133333 0 0 0 31.232 47.957333c13.141333 0 25.6-7.509333 31.232-20.309333 2.730667-5.973333 5.12-12.117333 7.509334-18.090667 6.826667-17.578667-1.877333-37.376-19.456-44.202666zM952.32 547.84c-0.341333-18.773333-15.189333-33.962667-34.816-33.450667-18.773333 0.341333-33.792 16.042667-33.450667 34.816 0 2.730667 0.170667 5.461333 0 8.533334v8.021333c-0.512 18.773333 14.506667 34.474667 33.28 34.816h0.853334c18.432 0 33.621333-14.848 34.133333-33.28 0-3.242667 0.170667-6.314667 0.170667-9.386667 0-3.242667-0.170667-6.656-0.170667-10.069333zM779.093333 819.541333c-3.754667 3.925333-7.68 7.850667-11.776 11.776-13.653333 13.141333-13.994667 34.645333-1.024 48.298667 6.656 6.997333 15.701333 10.410667 24.576 10.410667 8.533333 0 17.066667-3.242667 23.722667-9.557334 4.608-4.437333 9.216-9.045333 13.653333-13.653333 12.970667-13.653333 12.629333-35.157333-1.024-48.298667-13.482667-12.970667-34.986667-12.458667-48.128 1.024zM513.194667 936.448h-7.68c-18.773333 0-34.133333 15.36-34.133334 34.133333s15.36 34.133333 34.133334 34.133334c3.072 0 6.314667 0 9.386666-0.170667 18.773333-0.512 33.792-16.042667 33.28-34.986667s-16.042667-34.304-34.986666-33.109333zM660.821333 736.085333c13.312-13.312 13.312-34.986667 0-48.298666l-120.832-120.832V366.933333c0-18.773333-15.36-34.133333-34.133333-34.133333s-34.133333 15.36-34.133333 34.133333v228.352l140.8 140.8a34.013867 34.013867 0 0 0 48.298666 0z"
                    fill="#231815"
                    p-id="5582"
                  />
                </svg>
                &nbsp;&nbsp;展示词频
              </template>
            </el-menu-item>
            <el-menu-item index="4" @click="onOpen(4)">
              <template slot="title">
                <svg
                  t="1653493391428"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1566"
                  data-darkreader-inline-fill
                  width="20"
                  height="20"
                >
                  <path
                    d="M512 384l147.2 76.8L576 601.6s0 6.4-6.4 6.4l-12.8 19.2c-25.6 25.6-70.4 32-102.4 19.2-38.4-19.2-51.2-70.4-32-108.8v-6.4L512 384z"
                    fill="#231815"
                    opacity=".1"
                    p-id="1567"
                    style="--darkreader-inline-fill: #1c1311;"
                    data-darkreader-inline-fill
                  />
                  <path
                    d="M224 832v-140.8L320 704l128 64 192-32 64-128L768 512l32-32V832h-576z"
                    fill="#231815"
                    opacity=".1"
                    p-id="1568"
                    style="--darkreader-inline-fill: #1c1311;"
                    data-darkreader-inline-fill
                  />
                  <path
                    d="M492.8 742.4c-25.6 0-57.6-6.4-76.8-19.2-38.4-19.2-64-57.6-76.8-96-12.8-44.8-6.4-89.6 19.2-128l121.6-204.8 44.8-12.8 83.2 51.2 70.4-128-89.6-51.2 32-57.6 224 128-32 57.6-83.2-51.2-70.4 128 83.2 51.2 12.8 44.8-121.6 204.8c-19.2 38.4-57.6 64-96 76.8-12.8 0-32 6.4-44.8 6.4zM512 352L409.6 531.2c-12.8 25.6-12.8 51.2-6.4 76.8 6.4 25.6 25.6 44.8 44.8 57.6 19.2 12.8 51.2 19.2 70.4 12.8 25.6-6.4 44.8-25.6 57.6-44.8L678.4 448 512 352z"
                    fill="#231815"
                    p-id="1569"
                    style="--darkreader-inline-fill: #1c1311;"
                    data-darkreader-inline-fill
                  />
                  <path
                    d="M896 928H128l-32-32v-192h64v160h704v-384h64V896z"
                    fill="#231815"
                    p-id="1570"
                    style="--darkreader-inline-fill: #1c1311;"
                    data-darkreader-inline-fill
                  />
                </svg>
                &nbsp;&nbsp;挖空词频
              </template>
            </el-menu-item>
          </el-menu>
        </el-header>

        <el-container style="height: 100%">
          <!-- 历史查询/统计 -->
          <div
            v-if="type==3 || type==2 || type==4"
            class="row"
            style="width:100%;height:100%;margin-left: 10px;position: relative;background: white;"
          >
            <div class="row select-date">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
              <el-button style="margin-left:10px;" @click="onSelect">查询</el-button>
            </div>
            <!-- 历史查询 -->
            <el-table
              v-if="type==3"
              :data="logList"
              style="margin-top: 35px; "
              height="calc(100% - 50px)"
              @sort-change="onSortChange"
            >
              <el-table-column prop="rowIndex" label="序号" sortable="custom" />
              <el-table-column prop="content" label="单词" sortable="custom" />
              <el-table-column prop="count" label="查询次数" sortable="custom" />
              <el-table-column prop="lastTime" label="查询时间" sortable="custom">
                <template slot-scope="scope">
                  <span v-if="scope.row.lastTime">{{ scope.row.lastTime }}</span>
                  <span v-else>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 统计 -->
            <el-table
              v-if="type==2"
              height="calc(100% - 10px)"
              :data="statiList"
              @sort-change="onSortChange"
            >
              <el-table-column prop="rowIndex" label="序号" sortable="custom" />
              <el-table-column prop="content" label="单词" sortable="custom" />
              <el-table-column prop="count" label="展示次数" sortable="custom" />
              <el-table-column prop="lastTime" label="展示时间" sortable="custom">
                <template slot-scope="scope">
                  <span v-if="scope.row.lastTime">{{ scope.row.lastTime }}</span>
                  <span v-else>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 挖空 -->
            <el-table
              v-if="type==4"
              height="calc(100% - 10px)"
              :data="hollowList"
              @sort-change="onSortChange"
            >
              <el-table-column prop="rowIndex" label="序号" sortable="custom" />
              <el-table-column prop="content" label="单词" sortable="custom" />
              <el-table-column prop="count" label="挖空次数" sortable="custom" />
              <el-table-column prop="lastTime" label="挖空时间" sortable="custom">
                <template slot-scope="scope">
                  <span v-if="scope.row.lastTime">{{ scope.row.lastTime }}</span>
                  <span v-else>{{ scope.row.time }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="type==3 || type==2 || type==4" id="statistics" style="width: 550px;background: white;"></div>
            <div class="statistics column">
              <div class="row title">
                <span>查询</span>
                <span>数量</span>
              </div>
              <div class="row content">
                <div style="background:#53CC70;width: 5px;"></div>
                <span>8次以上</span>
                <span>{{ statistics.count8 }}</span>
              </div>
              <div class="row content">
                <div style="background:#3291F9;width: 5px;"></div>
                <span>7次</span>
                <span>{{ statistics.count7 }}</span>
              </div>
              <div class="row content">
                <div style="background:#59DBFF;width: 5px;"></div>
                <span>6次</span>
                <span>{{ statistics.count6 }}</span>
              </div>
              <div class="row content">
                <div style="background:#F2BD42;width: 5px;"></div>
                <span>5次</span>
                <span>{{ statistics.count5 }}</span>
              </div>
              <div class="row content">
                <div style="background:#EE752E;width: 5px;"></div>
                <span>4次</span>
                <span>{{ statistics.count4 }}</span>
              </div>
              <div class="row content">
                <div style="background:#D95040;width: 5px;"></div>
                <span>3次以下</span>
                <span>{{ statistics.count3 }}</span>
              </div>
              <div class="row content">
                <div style="background:rgb(90 86 86);width: 5px;"></div>
                <span>单词总数</span>
                <span v-if="type==2">{{ statiList.length }}</span>
                <span v-else-if="type==4">{{ hollowList.length }}</span>
                <span v-else>{{ logList.length }}</span>
              </div>
            </div>
          </div>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { list, deWord, statistics } from '@/apis/word-library'
import router from '@/router'
var that
export default {
  name: 'Index',
  components: {},
  data() {
    return {
      service: Vue.$conf.service[Vue.$conf.environment],
      selectionValue: 'Im',
      dayList: [],
      logList: [],
      statiList: [],
      hollowList: [],
      iframeWidth: 1000,
      iframeHeight: 1000,
      isFindIframe: false,
      type: 0,
      charts: '',
      opinionData: [
        { value: 0, name: '8次以上', itemStyle: '#53CC70' },
        { value: 0, name: '7次', itemStyle: '#3291F9' },
        { value: 0, name: '6次', itemStyle: '#59DBFF' },
        { value: 0, name: '5次', itemStyle: '#F2BD42' },
        { value: 0, name: '4次', itemStyle: '#EE752E' },
        { value: 0, name: '3次以下', itemStyle: '#D95040' }
      ],
      statistics: {
        count8: 0,
        count7: 0,
        count6: 0,
        count5: 0,
        count4: 0,
        count3: 0
      },
      date: [],
      audio: {}, // 音频播放
      dayListItem: {}, // 上一个词
      isWordShow: false, // 词是否显示
      isSentenceShow: false, // 句是否显示
      sidx: '' // 排序列
    }
  },
  mounted() {
    that = this
    that.iframeWidth = document.documentElement.clientWidth - 200 - 235
    that.iframeHeight = document.documentElement.clientHeight - 120
  },
  created() {
    this.audio = new Audio()
    // 窗口变化
    window.onresize = function() {
      that.iframeWidth = document.documentElement.clientWidth - 200 - 235
      that.iframeHeight = document.documentElement.clientHeight - 120
    }
    var jurisdiction = JSON.parse(localStorage.getItem('user')).jurisdiction
    if (!jurisdiction.menus['wfs']) {
      router.push({
        name: 'Noaccess'
      })
      return
    }
    that.onOpen(3)
  },
  methods: {
    // 加载记录
    onOpen(e) {
      console.log(that.sidx)
      if (e === 1) {
        var div = document.getElementById('statistics')
        if (div) {
          that.$echarts.init(document.getElementById('statistics')).dispose()
        }
      }
      that.type = e
      var date = []
      if (e === 3) date = that.date
      list({ type: e, date, page: { sidx: that.sidx } }).then(res => {
        switch (e) {
          case 1:
            that.dayList = res.data
            if (that.dayList.length > 0) {
              that.onPronounce(that.dayList[0].content)
            }
            break
          case 2:
            that.statiList = res.data
            statistics({ date: [], type: 2 }).then(s => {
              that.opinionData[0].value = s.data.count8
              that.opinionData[1].value = s.data.count7
              that.opinionData[2].value = s.data.count6
              that.opinionData[3].value = s.data.count5
              that.opinionData[4].value = s.data.count4
              that.opinionData[5].value = s.data.count3
              that.statistics = s.data
              // console.log(that.statistics)
              that.$nextTick(function() {
                that.drawPie('statistics')
              })
            })
            break
          case 3:
            that.logList = res.data
            statistics({ date: that.date, type: 3 }).then(s => {
              that.opinionData[0].value = s.data.count8
              that.opinionData[1].value = s.data.count7
              that.opinionData[2].value = s.data.count6
              that.opinionData[3].value = s.data.count5
              that.opinionData[4].value = s.data.count4
              that.opinionData[5].value = s.data.count3
              that.statistics = s.data
              // console.log(that.statistics)
              that.$nextTick(function() {
                that.drawPie('statistics')
              })
            })
            break
          case 4:
            that.hollowList = res.data
            statistics({ date: that.date, type: 4 }).then(s => {
              that.opinionData[0].value = s.data.count8
              that.opinionData[1].value = s.data.count7
              that.opinionData[2].value = s.data.count6
              that.opinionData[3].value = s.data.count5
              that.opinionData[4].value = s.data.count4
              that.opinionData[5].value = s.data.count3
              that.statistics = s.data
              // console.log(that.statistics)
              that.$nextTick(function() {
                that.drawPie('statistics')
              })
            })
            break
        }
      })
    },
    // 下一个单词
    onNext() {
      if (that.dayList.length > 1) that.dayListItem = that.dayList[0]
      deWord({ uwlId: that.dayList[0].id })
      that.dayList.shift()
      that.isFindIframe = false
      that.isWordShow = false
      that.isSentenceShow = false
      if (that.dayList.length > 0) {
        that.onPronounce(that.dayList[0].content)
      }
    },
    // 查词
    onFind() {
      if (that.dayList.length === 0) return
      that.isFindIframe = true
      that.selectionValue = that.dayList[0].content
    },
    // 饼状图
    drawPie(id) {
      this.charts = that.$echarts.init(document.getElementById(id))
      this.charts.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a}<br/>{b}:{c} ({d}%)'
        },
        legend: {
          data: ['直接访问'],
          left: 'center',
          top: 'bottom',
          orient: 'horizontal'
        },
        series: [
          {
            name: '统计',
            type: 'pie',
            radius: '50%',
            center: ['50%', '200px'],
            avoidLabelOverlap: false,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              color: function(params) {
                return params.data.itemStyle
              }
            },
            data: this.opinionData
          }
        ]
      })
    },
    // 历史查询 日期搜索
    onSelect() {
      if (!that.date) {
        that.date = []
      }
      that.onOpen(3)
    },
    // 撤销
    onBackout() {
      if (that.dayListItem.en) {
        that.dayList.splice(0, 0, that.dayListItem)
        that.dayListItem = {}
        that.isWordShow = false
        that.isSentenceShow = false
      }
    },
    // 发音
    onPronounce(text) {
      that.audio.src = `http://dict.youdao.com/speech?audio=${text}`
      that.audio.play()
    },
    // 排序
    onSortChange(obj) {
      if (obj.order === null) this.sidx = ''
      else if (obj.prop) {
        var order = obj.order === 'ascending' ? '' : 'desc'
        this.sidx = obj.prop + ' ' + order
      }
      this.onOpen(that.type)
    }
  }
}
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}
.header {
  background: rgb(198, 18, 0) none repeat scroll 0% 0%;
  display: flex;
  //   justify-content: center;
  align-items: center;
  .image {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    margin-left: 20px;
  }
  span {
    font-size: 14px;
    color: white;
    margin-left: 20px;
  }
}
.day-left {
  margin-left: 10px;
  height: 100%;
  width: 200px;
  .day-margin {
    width: 200px;
    height: 30px;
    background: rgb(238, 238, 238);
    border: 1px solid rgb(197, 197, 197);
    border-radius: 6px;
    // 左右上下居中
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
  }
  .day-word {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #4c4a4a;
    span {
      max-width: 180px;
      word-break: break-all;
      margin-left: 5px;
    }
  }
  .margintop {
    margin-top: 10px;
  }
}
.select-date {
  position: absolute;
  left: 4px;
  top: 4px;
}
.statistics {
  // background: red;
  width: 370px;
  height: 100px;
  position: absolute;
  top: 380px;
  right: 0px;
  padding-left: 50px;
  .title span {
    font-size: 14px;
    font-weight: bold;
    width: 170px;
    padding-bottom: 10px;
  }
  .content span {
    margin-left: 5px;
    padding: 5px 0px;
    font-size: 12px;
    width: 163px;
  }
}
</style>
